// Ginox Steel theme — small interactions
(function () {
  'use strict';
  // Only toggle active state on the homepage chip filter
  const chips = document.querySelectorAll('.cat-strip .cat-chip');
  chips.forEach(chip => {
    chip.addEventListener('click', function(e) {
      // If this chip is a link with a real URL, let the browser navigate
      // Only do the active-toggle if it's meant as a client-side filter
    });
  });
})();
